"use client";

import Link from 'next/link'

import { Container } from '@/components/common/Container'
import { FadeIn } from '@/components/FadeIn'
import {useLanguage} from "@/context/LanguageContext";
import {type Metadata} from 'next';

/*export const metadata: Metadata = {
  title: 'Page not found',
  description: 'Page not found.',
  robots: { index: false, follow: true },
}*/



const texts = {
  en: {
    pageNotFound: 'Page not found',
    description: 'Sorry, we couldn’t find the page you’re looking for.',
    goto: 'Go to the home page',
  },
  it: {
    pageNotFound: 'Pagina non trovata',
    description: 'Spiacenti, non abbiamo trovato la pagina che stai cercando.',
    goto: 'Vai alla home page',
  },
};

export default function NotFound() {
  const { language } = useLanguage();
  return (
    <Container className="flex h-full items-center pt-24 sm:pt-32 lg:pt-40">
      <FadeIn className="flex max-w-xl flex-col items-center text-center">
        <p className="font-display text-4xl font-semibold text-neutral-950 sm:text-5xl">
          404
        </p>
        <h1 className="mt-4 font-display text-2xl font-semibold text-neutral-950">
          { texts[language as keyof typeof texts]?.pageNotFound || texts['en'].pageNotFound }
        </h1>
        <p className="mt-2 text-sm text-neutral-600">
          { texts[language as keyof typeof texts]?.description || texts['en'].description }
        </p>
        <Link
          href="/"
          className="mt-4 text-sm font-semibold text-neutral-950 transition hover:text-neutral-700"
        >
          { texts[language as keyof typeof texts]?.goto || texts['en'].goto }
        </Link>
      </FadeIn>
    </Container>
  )
}
